<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { page } from '$app/stores';
	import { isSideBarOpen } from '../stores';
	import { isRTL } from '$lib/stores/directionStore';
	import { linkToggle } from '$lib/actions/linkToggle';
	import type { Collection } from '$lib/types/Collections';

	export let collection: Collection;

	const hubPrefix = $page.params.hubPrefix;
	const isSelected = $page.data.postsFilters?.collectionSlug == collection.slug;

	$: tagsHidden = true;
	const toggleTagsHidden = () => {
		tagsHidden = !tagsHidden;
	};
	const closeSideBar = () => {
		$isSideBarOpen = false;
	};

	const hasTags = collection.tags && collection.tags.length > 0;
</script>

<li>
	<div class="itemWrapper">
		<div class="tagButtonWrapper">
			{#if hasTags}
				<button type="button" on:click={toggleTagsHidden}>
					<Icon icon={$isRTL ? 'left-chevron' : 'right-chevron'} size="20" clickable />
				</button>
			{/if}
		</div>
		<a
			use:linkToggle={$page}
			href={`/${hubPrefix}/${collection.slug}`}
			on:click={closeSideBar}
			class:isSelected>
			{collection.name}
		</a>
	</div>
	{#if hasTags}
		<ul class:tagsHidden>
			{#each collection?.tags ?? [] as tag}
				<li>
					<a
						class="tag"
						use:linkToggle={$page}
						href={`/${hubPrefix}/${collection.slug}?tag=${tag}`}
						on:click={closeSideBar}>
						#{tag}
					</a>
				</li>
			{/each}
		</ul>
	{/if}
</li>

<style>
	li {
		background-color: white;
		color: rgb(76 83 93);
		border-block-end: 1px solid rgb(238 238 238);
	}

	.itemWrapper {
		display: flex;
		align-items: center;
		overflow: hidden;
	}

	a {
		min-block-size: 45px;
		inline-size: 100%;
		padding-block: 0;
		padding-inline: 0 27px;
		overflow: hidden;
		color: rgb(76 83 93);
		font-size: 15px;
		line-height: 45px;
	}

	.isSelected {
		font-weight: 400;
	}

	.tagButtonWrapper {
		inline-size: 45px;
		padding: 10px;
	}

	li:hover {
		background-color: rgb(248 248 248);
	}

	.tagsHidden {
		display: none;
	}

	.tag {
		padding-inline: 45px;
		color: black;
	}

	button {
		padding: 0;
		border-width: 0;
		background-color: transparent;
	}
</style>
